import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87f41d6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-target", "aria-controls"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "float-right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-up" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["id", "aria-labelledby"]
const _hoisted_12 = { class: "row mb-2 align-items-start" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "病院・診療所区分")
], -1))
const _hoisted_14 = { class: "col-5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_16 = ["value", "textContent"]
const _hoisted_17 = ["textContent"]
const _hoisted_18 = { class: "row mb-2 align-items-start" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "都道府県コード(施設)")
], -1))
const _hoisted_20 = { class: "col-5" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_22 = ["value", "textContent"]
const _hoisted_23 = ["textContent"]
const _hoisted_24 = { class: "row mb-2 align-items-start" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "病床・外来管理番号有無")
], -1))
const _hoisted_26 = { class: "col-5" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_28 = ["value", "textContent"]
const _hoisted_29 = ["textContent"]
const _hoisted_30 = { class: "row mb-2 align-items-start" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "病床・外来管理番号")
], -1))
const _hoisted_32 = { class: "col-5" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["textContent"]
const _hoisted_35 = { class: "row mb-2 align-items-start" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "医療機関コード有無")
], -1))
const _hoisted_37 = { class: "col-5" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_39 = ["value", "textContent"]
const _hoisted_40 = ["textContent"]
const _hoisted_41 = { class: "row mb-2 align-items-start" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "医療機関コード")
], -1))
const _hoisted_43 = { class: "col-5" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["textContent"]
const _hoisted_46 = { class: "row mb-2 align-items-start" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "病院・診療所名")
], -1))
const _hoisted_48 = { class: "col-5" }
const _hoisted_49 = ["textContent"]
const _hoisted_50 = { class: "row mb-2 align-items-start" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "役員数")
], -1))
const _hoisted_52 = { class: "col-5" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["textContent"]
const _hoisted_55 = { class: "row mb-2 align-items-start" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "職員数")
], -1))
const _hoisted_57 = { class: "col-5" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["textContent"]
const _hoisted_60 = { class: "row mb-2 align-items-start" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "都道府県")
], -1))
const _hoisted_62 = { class: "col-5" }
const _hoisted_63 = ["textContent"]
const _hoisted_64 = { class: "row mb-2 align-items-start" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "市区町村")
], -1))
const _hoisted_66 = { class: "col-5" }
const _hoisted_67 = ["textContent"]
const _hoisted_68 = { class: "row mb-2 align-items-start" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "町域")
], -1))
const _hoisted_70 = { class: "col-5" }
const _hoisted_71 = ["textContent"]
const _hoisted_72 = { class: "row mb-2 align-items-start" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "二次医療圏")
], -1))
const _hoisted_74 = { class: "col-5" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = ["textContent"]
const _hoisted_77 = { class: "row mb-2 align-items-start" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "消費税の経理方式")
], -1))
const _hoisted_79 = { class: "col-5" }
const _hoisted_80 = ["disabled"]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_82 = ["value", "textContent"]
const _hoisted_83 = ["textContent"]
const _hoisted_84 = { class: "row mb-2 align-items-start" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "主たる診療科１")
], -1))
const _hoisted_86 = { class: "col-5" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_89 = ["value", "textContent"]
const _hoisted_90 = ["textContent"]
const _hoisted_91 = { class: "row mb-2 align-items-start" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "主たる診療科２")
], -1))
const _hoisted_93 = { class: "col-5" }
const _hoisted_94 = ["disabled"]
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_96 = ["value", "textContent"]
const _hoisted_97 = ["textContent"]
const _hoisted_98 = { class: "row mb-2 align-items-start" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "主たる診療科３")
], -1))
const _hoisted_100 = { class: "col-5" }
const _hoisted_101 = ["disabled"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_103 = ["value", "textContent"]
const _hoisted_104 = ["textContent"]
const _hoisted_105 = { class: "row mb-2 align-items-start" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "[病床機能報告」報告の有無")
], -1))
const _hoisted_107 = { class: "col-5" }
const _hoisted_108 = ["disabled"]
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_110 = ["value", "textContent"]
const _hoisted_111 = ["textContent"]
const _hoisted_112 = { class: "row mb-2 align-items-start" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "出力設定")
], -1))
const _hoisted_114 = { class: "col-5" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_116 = ["value", "textContent"]
const _hoisted_117 = ["textContent"]
const _hoisted_118 = { class: "row mb-2 align-items-start" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "部門グループ")
], -1))
const _hoisted_120 = { class: "col-5" }
const _hoisted_121 = ["disabled"]
const _hoisted_122 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "card-header",
      id: 'facility-item-header-' + _ctx.item.item.facilityKey
    }, [
      _createElementVNode("button", {
        class: "btn btn-link",
        type: "button",
        "data-toggle": "collapse",
        "data-target": '#facility-item-' + _ctx.item.item.facilityKey,
        "aria-expanded": "false",
        "aria-controls": 'facility-item-' + _ctx.item.item.facilityKey
      }, [
        _createElementVNode("span", {
          textContent: _toDisplayString(_ctx.headerName)
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_2),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-link",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickedUpItem && _ctx.onClickedUpItem(...args)))
            }, _hoisted_6))
          : _createCommentVNode("", true),
        (!_ctx.isLast)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-link",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickedDownItem && _ctx.onClickedDownItem(...args)))
            }, _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-link",
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickedTrashItem && _ctx.onClickedTrashItem(...args)))
        }, _hoisted_10)
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      id: 'facility-item-' + _ctx.item.item.facilityKey,
      class: "collapse",
      "aria-labelledby": 'facility-item-header-' + _ctx.item.item.facilityKey
    }, [
      _createElementVNode("div", {
        class: "card-body",
        onInput: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
        onChange: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
      }, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.hospitalClinicKbn }]),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.values.hospitalClinicKbn) = $event))
            }, [
              _hoisted_15,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hospitalClinicKbns, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.code,
                  value: t.code,
                  textContent: _toDisplayString(t.displayName)
                }, null, 8, _hoisted_16))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.values.hospitalClinicKbn]
            ])
          ]),
          (_ctx.errors.hospitalClinicKbn)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.hospitalClinicKbn)
              }, null, 8, _hoisted_17))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.prefectureCode }]),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.values.prefectureCode) = $event))
            }, [
              _hoisted_21,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prefectures, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.code,
                  value: t.code,
                  textContent: _toDisplayString(t.displayName)
                }, null, 8, _hoisted_22))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.values.prefectureCode]
            ])
          ]),
          (_ctx.errors.prefectureCode)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.prefectureCode)
              }, null, 8, _hoisted_23))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.hasBedOutpatientMgmtNumber }]),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.values.hasBedOutpatientMgmtNumber) = $event))
            }, [
              _hoisted_27,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hasCodes, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.code,
                  value: t.code,
                  textContent: _toDisplayString(t.displayName)
                }, null, 8, _hoisted_28))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.values.hasBedOutpatientMgmtNumber]
            ])
          ]),
          (_ctx.errors.hasBedOutpatientMgmtNumber)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.hasBedOutpatientMgmtNumber)
              }, null, 8, _hoisted_29))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.bedOutpatientMgmtNumber }]),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.values.bedOutpatientMgmtNumber) = $event)),
              placeholder: "病床・外来管理番号",
              disabled: _ctx.values.hasBedOutpatientMgmtNumber === _ctx.HasCodeType.No
            }, null, 10, _hoisted_33), [
              [_vModelText, _ctx.values.bedOutpatientMgmtNumber]
            ])
          ]),
          (_ctx.errors.bedOutpatientMgmtNumber)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.bedOutpatientMgmtNumber)
              }, null, 8, _hoisted_34))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.hasMedicalInstitutionCode }]),
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.values.hasMedicalInstitutionCode) = $event))
            }, [
              _hoisted_38,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hasCodes, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.code,
                  value: t.code,
                  textContent: _toDisplayString(t.displayName)
                }, null, 8, _hoisted_39))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.values.hasMedicalInstitutionCode]
            ])
          ]),
          (_ctx.errors.hasMedicalInstitutionCode)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.hasMedicalInstitutionCode)
              }, null, 8, _hoisted_40))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.medicalInstitutionCode }]),
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.values.medicalInstitutionCode) = $event)),
              placeholder: "医療機関コード",
              disabled: _ctx.values.hasMedicalInstitutionCode === _ctx.HasCodeType.No
            }, null, 10, _hoisted_44), [
              [_vModelText, _ctx.values.medicalInstitutionCode]
            ])
          ]),
          (_ctx.errors.medicalInstitutionCode)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.medicalInstitutionCode)
              }, null, 8, _hoisted_45))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.hospitalClinicName }]),
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.values.hospitalClinicName) = $event)),
              placeholder: "病院・診療所名"
            }, null, 2), [
              [_vModelText, _ctx.values.hospitalClinicName]
            ])
          ]),
          (_ctx.errors.hospitalClinicName)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.hospitalClinicName)
              }, null, 8, _hoisted_49))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.executiveCount }]),
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.values.executiveCount) = $event)),
              placeholder: "役員数",
              disabled: _ctx.values.hospitalClinicKbn === _ctx.hospitalClinicKbnType.NonReportable
            }, null, 10, _hoisted_53), [
              [_vModelText, _ctx.values.executiveCount]
            ])
          ]),
          (_ctx.errors.executiveCount)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.executiveCount)
              }, null, 8, _hoisted_54))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.staffCount }]),
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.values.staffCount) = $event)),
              placeholder: "職員数",
              disabled: _ctx.values.hospitalClinicKbn === _ctx.hospitalClinicKbnType.NonReportable
            }, null, 10, _hoisted_58), [
              [_vModelText, _ctx.values.staffCount]
            ])
          ]),
          (_ctx.errors.staffCount)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.staffCount)
              }, null, 8, _hoisted_59))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          _createElementVNode("div", _hoisted_62, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.prefecture }]),
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.values.prefecture) = $event)),
              placeholder: "都道府県"
            }, null, 2), [
              [_vModelText, _ctx.values.prefecture]
            ])
          ]),
          (_ctx.errors.prefecture)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.prefecture)
              }, null, 8, _hoisted_63))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_64, [
          _hoisted_65,
          _createElementVNode("div", _hoisted_66, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.municipality }]),
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.values.municipality) = $event)),
              placeholder: "市区町村"
            }, null, 2), [
              [_vModelText, _ctx.values.municipality]
            ])
          ]),
          (_ctx.errors.municipality)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.municipality)
              }, null, 8, _hoisted_67))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_68, [
          _hoisted_69,
          _createElementVNode("div", _hoisted_70, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.townArea }]),
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.values.townArea) = $event)),
              placeholder: "町域"
            }, null, 2), [
              [_vModelText, _ctx.values.townArea]
            ])
          ]),
          (_ctx.errors.townArea)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.townArea)
              }, null, 8, _hoisted_71))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_72, [
          _hoisted_73,
          _createElementVNode("div", _hoisted_74, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.secondaryMedicalArea }]),
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.values.secondaryMedicalArea) = $event)),
              placeholder: "二次医療圏",
              disabled: _ctx.values.hospitalClinicKbn === _ctx.hospitalClinicKbnType.NonReportable
            }, null, 10, _hoisted_75), [
              [_vModelText, _ctx.values.secondaryMedicalArea]
            ])
          ]),
          (_ctx.errors.secondaryMedicalArea)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.secondaryMedicalArea)
              }, null, 8, _hoisted_76))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_77, [
          _hoisted_78,
          _createElementVNode("div", _hoisted_79, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.taxAccountingMethod }]),
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.values.taxAccountingMethod) = $event)),
              disabled: _ctx.values.hospitalClinicKbn === _ctx.hospitalClinicKbnType.NonReportable
            }, [
              _hoisted_81,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxAccountingMethods, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.code,
                  value: t.code,
                  textContent: _toDisplayString(t.displayName)
                }, null, 8, _hoisted_82))
              }), 128))
            ], 10, _hoisted_80), [
              [_vModelSelect, _ctx.values.taxAccountingMethod]
            ])
          ]),
          (_ctx.errors.taxAccountingMethod)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.taxAccountingMethod)
              }, null, 8, _hoisted_83))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_84, [
          _hoisted_85,
          _createElementVNode("div", _hoisted_86, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.primarySpecialty1 }]),
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.values.primarySpecialty1) = $event)),
              disabled: _ctx.values.hospitalClinicKbn !== _ctx.hospitalClinicKbnType.Clinic
            }, [
              _hoisted_88,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialties, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.code,
                  value: t.code,
                  textContent: _toDisplayString(t.displayName)
                }, null, 8, _hoisted_89))
              }), 128))
            ], 10, _hoisted_87), [
              [_vModelSelect, _ctx.values.primarySpecialty1]
            ])
          ]),
          (_ctx.errors.primarySpecialty1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.primarySpecialty1)
              }, null, 8, _hoisted_90))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_91, [
          _hoisted_92,
          _createElementVNode("div", _hoisted_93, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.primarySpecialty2 }]),
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.values.primarySpecialty2) = $event)),
              disabled: _ctx.values.hospitalClinicKbn !== _ctx.hospitalClinicKbnType.Clinic
            }, [
              _hoisted_95,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialties, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.code,
                  value: t.code,
                  textContent: _toDisplayString(t.displayName)
                }, null, 8, _hoisted_96))
              }), 128))
            ], 10, _hoisted_94), [
              [_vModelSelect, _ctx.values.primarySpecialty2]
            ])
          ]),
          (_ctx.errors.primarySpecialty2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.primarySpecialty2)
              }, null, 8, _hoisted_97))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_98, [
          _hoisted_99,
          _createElementVNode("div", _hoisted_100, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.primarySpecialty3 }]),
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.values.primarySpecialty3) = $event)),
              disabled: _ctx.values.hospitalClinicKbn !== _ctx.hospitalClinicKbnType.Clinic
            }, [
              _hoisted_102,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialties, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.code,
                  value: t.code,
                  textContent: _toDisplayString(t.displayName)
                }, null, 8, _hoisted_103))
              }), 128))
            ], 10, _hoisted_101), [
              [_vModelSelect, _ctx.values.primarySpecialty3]
            ])
          ]),
          (_ctx.errors.primarySpecialty3)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.primarySpecialty3)
              }, null, 8, _hoisted_104))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_105, [
          _hoisted_106,
          _createElementVNode("div", _hoisted_107, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.hasBedFunctionReport }]),
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.values.hasBedFunctionReport) = $event)),
              disabled: _ctx.values.hospitalClinicKbn === _ctx.hospitalClinicKbnType.NonReportable
            }, [
              _hoisted_109,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hasBedFunctionReports, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.code,
                  value: t.code,
                  textContent: _toDisplayString(t.displayName)
                }, null, 8, _hoisted_110))
              }), 128))
            ], 10, _hoisted_108), [
              [_vModelSelect, _ctx.values.hasBedFunctionReport]
            ])
          ]),
          (_ctx.errors.hasBedFunctionReport)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.hasBedFunctionReport)
              }, null, 8, _hoisted_111))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_112, [
          _hoisted_113,
          _createElementVNode("div", _hoisted_114, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.outputSetting }]),
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.values.outputSetting) = $event))
            }, [
              _hoisted_115,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outputSettings, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.code,
                  value: t.code,
                  textContent: _toDisplayString(t.displayName)
                }, null, 8, _hoisted_116))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.values.outputSetting]
            ])
          ]),
          (_ctx.errors.outputSetting)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.outputSetting)
              }, null, 8, _hoisted_117))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_118, [
          _hoisted_119,
          _createElementVNode("div", _hoisted_120, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.bmnGroup }]),
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.values.bmnGroup) = $event)),
              placeholder: "部門グループ",
              disabled: _ctx.values.outputSetting !== _ctx.OutputSettingType.BmnGroup || _ctx.values.hospitalClinicKbn === _ctx.hospitalClinicKbnType.NonReportable
            }, null, 10, _hoisted_121), [
              [_vModelText, _ctx.values.bmnGroup]
            ])
          ]),
          (_ctx.errors.bmnGroup)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-4 error-text",
                textContent: _toDisplayString(_ctx.errors.bmnGroup)
              }, null, 8, _hoisted_122))
            : _createCommentVNode("", true)
        ])
      ], 32)
    ], 8, _hoisted_11)
  ], 64))
}